const CATEGORIES = {
  WALLS: 'walls',
  ROOF: 'roof',
  OPENINGS: 'openings',
};

const LABEL_IDS = {
  GLASS_ID: 100,
  ENTRY_DOOR_ID: 102,
  PATIO_DOOR_ID: 104,
  SLIDING_GLASS_DOOR_ID: 105,
  BRICK_ID: 200,
  STONE_ID: 202,
  WOOD_ID: 205,
  VINYL_ID: 206,
  STUCCO_ID: 209,
  CONCRETE_ID: 211,
  TUDOR_ID: 220,
  WRAP_ID: 221,
  UNKNOWN_ID: 222,
  WHITE_ID: 301,
  SHUTTER_ID: 400,
  TRIM_ID: 401,
  FASCIA_ID: 402,
  SOFFIT_ID: 403,
  ROOF_ID: 404,
  SASH_ID: 405,
  DOOR_PACKAGE: 408,
  OPENINGS_TRIM_ID: 409,
  HORIZONTAL_SIDING_ID: 601,
  VERTICAL_SIDING_ID: 602,
  SHINGLED_SIDING_ID: 603,
  OTHER_SIDING_ID: 604,
};

// these are the labels from machete that are relevant to design pro
// NOTE: the array order is the order they appear in the extended sidebar
const MATERIALS_ARRAY = [
  // Wall Materials
  {
    id: LABEL_IDS.HORIZONTAL_SIDING_ID,
    name: 'horizontal siding',
    category: CATEGORIES.WALLS,
  },
  {
    id: LABEL_IDS.SHINGLED_SIDING_ID,
    name: 'shingled siding',
    category: CATEGORIES.WALLS,
  },
  {
    id: LABEL_IDS.VERTICAL_SIDING_ID,
    name: 'vertical siding',
    category: CATEGORIES.WALLS,
  },
  {
    id: LABEL_IDS.OTHER_SIDING_ID,
    name: 'other siding',
    category: CATEGORIES.WALLS,
  },
  { id: LABEL_IDS.BRICK_ID, name: 'brick', category: CATEGORIES.WALLS },
  { id: LABEL_IDS.STONE_ID, name: 'stone', category: CATEGORIES.WALLS },
  { id: LABEL_IDS.STUCCO_ID, name: 'stucco', category: CATEGORIES.WALLS },
  { id: LABEL_IDS.CONCRETE_ID, name: 'concrete', category: CATEGORIES.WALLS },
  { id: LABEL_IDS.TUDOR_ID, name: 'tudor', category: CATEGORIES.WALLS },
  { id: LABEL_IDS.WRAP_ID, name: 'wrap', category: CATEGORIES.WALLS },
  { id: LABEL_IDS.TRIM_ID, name: 'trim', category: CATEGORIES.WALLS },
  { id: LABEL_IDS.UNKNOWN_ID, name: 'unknown', category: CATEGORIES.WALLS },
  // Roof Materials
  { id: LABEL_IDS.ROOF_ID, name: 'roof', category: CATEGORIES.ROOF },
  { id: LABEL_IDS.FASCIA_ID, name: 'fascia', category: CATEGORIES.ROOF },
  { id: LABEL_IDS.SOFFIT_ID, name: 'soffit', category: CATEGORIES.ROOF },
  // Openings
  { id: LABEL_IDS.GLASS_ID, name: 'glass', category: CATEGORIES.OPENINGS },
  { id: LABEL_IDS.SHUTTER_ID, name: 'shutter', category: CATEGORIES.OPENINGS },
  { id: LABEL_IDS.SASH_ID, name: 'windows', category: CATEGORIES.OPENINGS },
  {
    id: LABEL_IDS.PATIO_DOOR_ID,
    name: 'patio door',
    category: CATEGORIES.OPENINGS,
  },
  {
    id: LABEL_IDS.SLIDING_GLASS_DOOR_ID,
    name: 'sliding glass door',
    category: CATEGORIES.OPENINGS,
  },
  {
    id: LABEL_IDS.OPENINGS_TRIM_ID,
    name: 'openings trim',
    category: CATEGORIES.OPENINGS,
  },
];

const MATERIALS = MATERIALS_ARRAY.reduce((acc, material) => {
  acc[material.id] = material;
  return acc;
}, {});

const THREE_D_OPENING_MATERIAL_IDS = [
  LABEL_IDS.SASH_ID,
  LABEL_IDS.SLIDING_GLASS_DOOR_ID,
];

// This is not a real label id.
// It is an arbitrarily large number used for sorting purposes.
const MAX_MATERIAL_ID = 999;

const LEGACY_OPENINGS = new Set([
  100, // window glass
  101, // door
  102, // entry door
  103, // garage door
  104, // patio door
  105, // sliding glass door
]);

const OPENINGS = new Set([
  LABEL_IDS.SASH_ID, // window
  101, // door
  102, // entry door
  103, // garage door
  104, // patio door
  105, // sliding glass door
]);

const PAINT_MANUFACTURERS = [
  2, // Valspar
  59, // Behr
];

// Updating these materials happens using the Machete Feature API instead of
// segmentation tree operations
const FEATURE_API_MATERIAL_IDS = [
  LABEL_IDS.PATIO_DOOR_ID,
  LABEL_IDS.SLIDING_GLASS_DOOR_ID,
];

const PAINTABLE_MATERIALS = [
  LABEL_IDS.BRICK_ID,
  LABEL_IDS.FASCIA_ID,
  LABEL_IDS.HORIZONTAL_SIDING_ID,
  LABEL_IDS.OPENINGS_TRIM_ID,
  LABEL_IDS.OTHER_SIDING_ID,
  LABEL_IDS.SHINGLED_SIDING_ID,
  LABEL_IDS.SOFFIT_ID,
  LABEL_IDS.STUCCO_ID,
  LABEL_IDS.TRIM_ID,
  LABEL_IDS.TUDOR_ID,
  LABEL_IDS.VERTICAL_SIDING_ID,
  LABEL_IDS.VINYL_ID,
  LABEL_IDS.WOOD_ID,
];

export default {
  CATEGORIES,
  FEATURE_API_MATERIAL_IDS,
  MATERIALS,
  MATERIALS_ARRAY,
  MAX_MATERIAL_ID,
  LEGACY_OPENINGS,
  OPENINGS,
  ...LABEL_IDS,
  PAINT_MANUFACTURERS,
  PAINTABLE_MATERIALS,
  THREE_D_OPENING_MATERIAL_IDS,
};
